import React, { Component } from 'react';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { withTranslation } from 'react-i18next';

class WrappedKeyboardDatePicker extends Component {

    render() {
        return (
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardDatePicker
                    ampm={false}
                    clearable
                    inputVariant="outlined"
                    views={this.props.views}
                    size="small"
                    margin="dense"
                    format={this.props.format ? this.props.format : "DD-MM-YYYY"}
                    name={this.props.name}
                    label={this.props.label}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    fullWidth
                    required={this.props.required}
                    keyboardbuttonprops={{
                        'aria-label': 'change date',
                    }}
                />
            </MuiPickersUtilsProvider>
        );
    }
}

export default withTranslation()(WrappedKeyboardDatePicker);
